import { BrokerAgreementBorrower } from '../../../../../../../queries/brokerAgreementQueries';
import { BorrowerName } from './BorrowerName';
import { BorrowerAddress } from './BorrowerAddress';
import { BorrowerContact } from './BorrowerContact';

/** The agreement borrower's entity, name, TIN, business address and contact details. */
export const BorrowerContactDetails = ({ borrower }: { borrower: BrokerAgreementBorrower }) => {
    return (
        <div style={{ flex: '2 1 0', minWidth: 0 }}>
            <BorrowerName borrower={borrower} />
            <BorrowerAddress borrower={borrower} />
            <BorrowerContact borrower={borrower} />
        </div>
    );
};
